
export async function getForeignFiscalData(foreignFiscalDataRepository) {
  return foreignFiscalDataRepository.get()
}

